import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, } from 'react-router';
import { format } from 'date-fns';
import '../../public/css/media/_notification.scss';
import { getNotification, readNotification, readAllNotification } from '../actions/ParcelAction';
import { maskRedirectLink } from '../utils/utils';
import { notificationTemplate } from '../utils/notificationTemplate';
import { renderFlagSquareSmall } from '../utils/warehouseFlags';

class Notification extends Component {
  componentWillMount(){
    if (this.props.isAuthenticated && this.props.login.fetched){
      const id = this.props.login.login.party.party_id;
      this.props.getNotification(id);
    }
  }  
  componentWillReceiveProps(nextProps){
  }
  handleClick(id, data) {
    const read = 1;
    this.props.readNotification(id,read);
    if (data && data.redirection_type === 'delivered') {
      window.open(
        `https://www.surveymonkey.com/r/shippingcart?account_number=${data.account_number}&tracking_number=${data.tracking_number}&date_delivered=${data.delivered_date}&origin_country=${data.origin}&shipment_method=${data.shipment_method}`,
        "_blank"
      );
    }
  }
  handleReadAll() {
    const read = 1;
    const id = this.props.parcel.notification_fetched ? this.props.parcel.notification.data[0].attributes.party_id : null;
    this.props.readAllNotification(id,read);
  }
  handleNotifIcon = (data) => {
    if (data.redirection_type === "vas_payment_failed") {
      return 'icon-request-payment-canceled-rejected';
    }
    if (data.redirection_type === "vas_rejected") {
      return 'icon-request-status-canceled-rejected';
    }
    if (data.redirection_type === "vas_approved") {
      return 'vas-status-inprogress';
    }
    return data.icon;
  }
  render() {
    const notification = this.props.parcel.notification_fetched ? this.props.parcel.notification.data : null;
    const notifLenght = this.props.parcel.notification_fetched ? this.props.parcel.notification.data.filter(notif => notif.attributes.read === 0).length : null;
    return (
      <div>
        <div className="body-wrapper container">
          <div className="notification-header">
            <div className="content">
              <h1>Notification{notification ? notification.length >= 2 ? "s" : null : null} &nbsp;
              {!notifLenght ? null : <span className="notif-count">{notifLenght !== 0 ? notifLenght : null} new</span>}
              {!notifLenght ? null : <span className="notification-mark" role="button" onClick={this.handleReadAll.bind(this)}>Mark all as read <span className="markasread icon-markasread" /> </span>}
              </h1>
            </div>
          </div>
          <ul>
            {notification ?
              notification.map(notif =>
                <li className={`notification-list ${notif.attributes.read === 0 ? `notif-unread` : ""} `} key={notif.id}>
                  <Link className="notification-link" to={maskRedirectLink(JSON.parse(notif.attributes.data), notif.attributes.reference_id)} onClick={this.handleClick.bind(this, notif.id, JSON.parse(notif.attributes.data))}>
                    <div direction="left"> 
                      <div className="f-left"><span className={`notification-icon ${this.handleNotifIcon(JSON.parse(notif.attributes.data))}`}/></div>
                      <div direction="right" className="notification-details">
                        {/* // JSON.parse(notif.attributes.data).redirection_type === "prohibited" 
                        // ? <span>{notif.attributes.template} <span className="notif-tracking">{notif.attributes.reference_id}</span></span> :
                        // JSON.parse(notif.attributes.data).redirection_type === "order_details" 
                        // ? <span><span className="notif-tracking">{JSON.parse(notif.attributes.data).tracking_number} </span>{notif.attributes.template}</span> : 
                        // JSON.parse(notif.attributes.data).redirection_type === "payment_success" ?
                        // <span>{notif.attributes.template} <span className="notif-tracking">{JSON.parse(notif.attributes.data).tracking_number}</span></span> :
                        // JSON.parse(notif.attributes.data).redirection_type === "payment_failed" ?
                        // <span>{notif.attributes.template} (Transaction #<span className="notif-tracking">{notif.attributes.reference_id}</span>)</span> : */}
                        {JSON.parse(notif.attributes.data).warehouse && <span className="notif-tracking">
                          <img src={renderFlagSquareSmall(JSON.parse(notif.attributes.data).warehouse)} alt="warehouse" style={{ width: '29px', height: '27px', margin: '-1px 0px -4px -5px' }} />
                          {notificationTemplate(notif.attributes)}
                        </span>}
                        <span>{notif.attributes.template}</span>
                        <div className="notif-date">{format(notif.attributes.created_at, "MM/DD/YYYY hh:mma")}</div>
                      </div>
                    </div> 
                  </Link>
                  <ul className={notif.attributes.read === 0 ? "mark-read" : "hide"}>
                    <li>
                      <i className="markread icon-markasread"  aria-hidden="true" role="button" onClick={this.handleClick.bind(this, notif.id)}></i>
                    </li>
                  </ul>
                </li>
              ): null
            }
          </ul>
        </div>
      </div>
    )
  }
}
const mapDispachToProps = { getNotification, readNotification, readAllNotification }

const mapStateToProps = state => ({
  parcel: state.parcel,
})

export default connect(mapStateToProps, mapDispachToProps)(Notification)
//export default Notification;


/** WEBPACK FOOTER **
 ** ./src/components/Notification.js
 **/